import { z } from "zod";

import { LiEventLocationType, LiEventScrapeStatus } from "@/enum/scrape-enum";
import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { PeopleSchema } from "../../Apollo/schema/get-people";

const { REQUIRED } = ERROR_TYPE;

export const LiEventEntryAttendeeSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	url: z.string().min(4, { message: REQUIRED }).trim(),
	description: z.string().trim(),
	companyName: z.string().trim(),
	attendees: z.number().nullable(),
	eventAt: z.string().nullable(),
	eventTill: z.string().nullable(),
	type: z.nativeEnum(LiEventLocationType),
	status: z.nativeEnum(LiEventScrapeStatus),
	prospect: PeopleSchema,
});

export const LiEventEntryAttendeeResponseSchema = z.object({
	data: z.array(LiEventEntryAttendeeSchema),
	meta: MetaDataSchema,
});

export type LiEventEntryAttendee = z.infer<typeof LiEventEntryAttendeeSchema>;

export type LiEventEntryAttendeeResponse = z.infer<typeof LiEventEntryAttendeeResponseSchema>;
